import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "w-full flex flex-row space-x-8"
}
const _hoisted_3 = {
  key: 0,
  class: "w-8/12"
}
const _hoisted_4 = {
  key: 1,
  class: "w-8/12"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-1/4 w-1/4 text-primary\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><div class=\"text-primary justify-center flex\"><span class=\"font-bold\">No invoices yet</span></div>", 2)
const _hoisted_7 = [
  _hoisted_5
]
const _hoisted_8 = { class: "w-4/12 space-y-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_BillingTable = _resolveComponent("BillingTable")!
  const _component_NextBilling = _resolveComponent("NextBilling")!
  const _component_PaymentMethods = _resolveComponent("PaymentMethods")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Loading, {
          active: _ctx.isLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
          "can-cancel": false,
          loader: "spinner",
          color: "#8908F9",
          width: 128,
          height: 128,
          "is-full-page": true
        }, null, 8, ["active"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (
        _ctx.subscriptions &&
        _ctx.subscriptions.stripe_transactions &&
        _ctx.subscriptions.stripe_transactions?.length > 0
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_BillingTable, {
                headers: _ctx.header,
                data: 
          _ctx.buildBillingTable(
            _ctx.subscriptions && _ctx.subscriptions.stripe_transactions
              ? _ctx.subscriptions.stripe_transactions
              : []
          )
        
              }, null, 8, ["headers", "data"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_NextBilling),
          _createVNode(_component_PaymentMethods)
        ])
      ]))
}